import { combineReducers } from 'redux';

import listings from './listings';
import cities from './cities';

export default combineReducers({
  listings,
  cities,
});
